import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { FooterCEG } from "@/components/FooterCEG";
import { PublicHeader } from "@/components/PublicHeader";

export default function IncentiviTerritorio() {
  const [regioni, setRegioni] = useState([]);
  useEffect(() => { document.title = "Incentivi per imprese per regione e città | BeAIchy"; api.get("/public/luoghi/elenco").then((r) => setRegioni(r.data)).catch(() => {}); }, []);
  return (
    <div className="min-h-screen bg-slate-50" data-testid="incentivi-territorio-page">
      <section className="bg-white text-slate-900"><PublicHeader testid="territorio-header" />
        <div className="px-6 sm:px-12 pt-6 pb-14 max-w-5xl">
          <p className="text-[11px] uppercase tracking-wider text-[#0070BA] inline-flex items-center gap-2"><MapPin size={12} /> Incentivi per territorio</p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] mt-4">Gli incentivi aperti nella tua città</h1>
          <p className="text-slate-700 mt-4 max-w-2xl text-sm sm:text-base">Scegli la regione o il capoluogo: bandi comunali, regionali e nazionali validi per la tua impresa, aggiornati ogni 6 ore dal collettore BeAIchy.</p>
        </div></section>
      <section className="px-6 sm:px-12 py-14 max-w-7xl mx-auto grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {regioni.map((r) => (
          <div key={r.slug} className="rounded-2xl border border-slate-200 bg-white p-5" data-testid={`territorio-regione-${r.slug}`}>
            <Link to={`/incentivi-imprese/${r.slug}`} className="font-heading text-lg font-semibold text-slate-900 hover:text-[#003087] inline-flex items-center gap-1">{r.regione} <ArrowRight size={14} /></Link>
            <div className="flex flex-wrap gap-1.5 mt-3">{r.comuni.map((c) => <Link key={c.slug} to={`/incentivi-imprese/${c.slug}`} className="rounded-full border border-slate-200 px-2.5 py-1 text-xs text-slate-700 hover:border-[#003087] hover:text-[#003087]" data-testid={`territorio-comune-${c.slug}`}>{c.nome}</Link>)}</div>
          </div>))}
      </section>
      <FooterCEG />
    </div>
  );
}
